import { useSearchParams } from "react-router";

/**
 * Returns a query string for the current URL.
 * @returns A query string for the current URL query parameters, empty string if there are no query parameters.
 */
export const useQueryString = () => {
  const [searchParams] = useSearchParams();
  const queryParams = Object.fromEntries(searchParams.entries());
  const queryString = Object.keys(queryParams).length > 0 ? `?${new URLSearchParams(queryParams).toString()}` : "";
  return queryString;
};
